import React from 'react';
import { ChevronLeftIcon } from '@heroicons/react/solid';
import { useNavigate } from 'react-router';

const PageHeaderDefaultProps = {
  backButton: null,
  children: null,
  onClick: () => null,
};

export type PageHeaderProps = {
  title: string;
  backButton?: string | null;
  children?: any;
  onClick?: (...args: any[]) => void;
} & typeof PageHeaderDefaultProps;

function PageHeader({
  title, backButton, children, onClick,
}: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap sm:flex-nowrap items-center mb-14 sm:mb-4 gap-4 h-14">
      <div
        className="flex"
      >
        {backButton && (
          <div role="button" onClick={() => { navigate(backButton); }}>
            <ChevronLeftIcon className="block h-14 w-14 hover:text-blue-900" aria-hidden="true" />
          </div>
        )}
        {!backButton && (
          <div role="button" onClick={() => { onClick(); }}>
            <ChevronLeftIcon className="block h-14 w-14 hover:text-blue-900" aria-hidden="true" />
          </div>
        )}
        <div className="flex items-center">
          <h3 className="text-2xl font-bold">{title}</h3>
        </div>
      </div>
      {children && (
        <div className="flex items-center gap-1">
          {children}
        </div>
      )}

    </div>
  );
};

PageHeader.defaultProps = PageHeaderDefaultProps;

export type PageHeaderButtonProps = {
  children: any,
  onClick: () => void
};

PageHeader.Button = function ({ children, onClick }: PageHeaderButtonProps) {
  return (
    <div
      role="button"
      className="bg-primary text-white hover:outline-8
      transition-all hover:outline-neutral-900 border-black flex text-md rounded-full focus:ring-white hover:text-blue-300 active:ring-2"
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default PageHeader;
